import {inject, injectable} from "inversify";
import type {IUser} from "data/stores/user/user.store";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";

export interface IUserLoginPayload {
	uid: string;
	email: string;
	platform: string;
}

export interface ILoginPayload {
	email: string;
	password: string;
}

type TLoginResponse = IApiResponse<{user: IUser; xSid: string}>;

export interface IAuthApiProvider {
	login: (params: IUserLoginPayload) => Promise<AxiosResponse<TLoginResponse>>;
	logout: () => Promise<AxiosResponse>;
	backdoor: (params: ILoginPayload) => Promise<AxiosResponse<TLoginResponse>>;
}

@injectable()
export class AuthApiProvider implements IAuthApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	login = (params: IUserLoginPayload) => this._http.post<TLoginResponse>("auth/login", params);

	logout = () => this._http.post("auth/logout");

	backdoor = (params: ILoginPayload) => this._http.post<TLoginResponse>("auth/backdoor", params);
}
